module.exports = __webpack_public_path__ + "static/media/burger.8e5229a9.svg";